export const HIDDEN_FIELDS: string[] = [
  "Unknown Event Name",
  "Non-Specified",
  "non specified",
];
